import React, { useState, useCallback, type MouseEvent, type KeyboardEvent } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import InfoIcon from '@atlaskit/icon/glyph/info';
import Popup from '@atlaskit/popup';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import InfoButtonToolTip from './info-button-tool-tip';

type Props = {
	message: string;
	ariaLabelText: string;
	action: {
		name: string;
		href: string;
	};
};

export const InfoButton = (props: Props) => {
	const { message, action, ariaLabelText } = props;
	const [isOpen, setIsOpen] = useState(false);

	const onCloseDialog = useCallback(
		(event: MouseEvent<Element, globalThis.MouseEvent> | KeyboardEvent<Element>) => {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			if ((event as KeyboardEvent).key === 'Escape') {
				event.stopPropagation();
			}
			setIsOpen(false);
		},
		[],
	);

	const onClick = () => {
		setIsOpen(!isOpen);
	};

	return (
		<Popup
			content={() => (
				<InfoButtonToolTip message={message} action={action} ariaLabelText={ariaLabelText} />
			)}
			isOpen={isOpen}
			onClose={onCloseDialog}
			placement="right"
			trigger={(triggerProps) => (
				<Button
					{...triggerProps}
					appearance="link"
					aria-label={action.name}
					aria-expanded={isOpen}
					onClick={onClick}
					spacing="none"
				>
					<IconContainer>
						<InfoIcon label="" size="small" />
					</IconContainer>
				</Button>
			)}
		/>
	);
};

export default InfoButton;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconContainer = styled.span({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.icon.discovery', colors.P300),
});
